var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeUa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 870,
    height: 381,
    viewBox: "0 0 870 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.279297 380.226L64.6633 0.964355L162.245 0.964355L238.198 203.17L313.648 0.964355L411.23 0.964355L475.614 380.226H377.529L344.834 161.924L255.3 380.226H216.066L131.059 161.924L98.3643 380.226H0.279297Z",
    fill: "#FDBB11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M588.868 0.964355V233.35L770.451 0.964355L869.039 0.964355V380.226H770.451V148.343L588.868 380.226H490.28V0.964355L588.868 0.964355Z",
    fill: "#FDBB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeUa);
export default __webpack_public_path__ + "static/media/we-ua.48a0363816a79fa15dede29510561e9d.svg";
export { ForwardRef as ReactComponent };